import React, { useRef } from 'react';
import * as S from './styles';

function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };

  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h4>QUEM SOMOS</h4>
            <h3>
              Coisa boa é quando a gente encontra amigues que têm uma proposta
              de trabalho afinada com a nossa.
            </h3>
          </div>
          <button onClick={scrollToDiv}>Conheça o Travessias</button>{' '}
          {/* Scroll para a div */}
        </S.TextDiv>
      </S.Section>
      <div ref={divRef} />
    </S.Main>
  );
}

export default Home1;
